<template>
  <div class="policy-page">
    <trsShopBreadcrumb
      class="policy-page__breadcrumb"
      :breadcrumbList="breadcrumbList"
      :skip="true"
    />
    <div class="policy-content">
      <section class="policy-section">
        <h3 class="policy-section__heading">OVERVIEW</h3>
        <p class="policy-text">
          This website is operated by TARAZON. Throughout this website, the terms "we", "us", and "our" refer to TARAZON. TARAZON provides this website, including all information, products, services, and tools available from this website to users, subject to the acceptance of all terms, conditions, policies, and notices stated herein.
        </p>
        <p class="policy-text">
          By accessing this website, placing an order, or using any service provided through this website, you agree to be bound by these Terms of Service.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 1 – ONLINE STORE TERMS</h3>
        <p class="policy-text">
          By using this website, you represent that you are at least the age of majority in your jurisdiction or have obtained appropriate consent from a parent or legal guardian.
        </p>
        <p class="policy-text">
          You may not use our products or services for any unlawful purpose or violate any applicable laws and regulations.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 2 – GENERAL CONDITIONS</h3>
        <p class="policy-text">
          We reserve the right to refuse service, cancel orders, or terminate accounts at our sole discretion.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 3 – ACCURACY OF INFORMATION</h3>
        <p class="policy-text">
          We strive to ensure that all information on this website is accurate and up to date. However, we do not guarantee the completeness, accuracy, or timeliness of any information displayed on this website.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 4 – PRODUCTS, SERVICES AND PRICING</h3>
        <p class="policy-text">
          All product descriptions, specifications, images, dimensions, and pricing displayed on this website are for reference purposes only and may be changed without prior notice.
        </p>
        <p class="policy-text">
          Product availability and pricing are subject to final confirmation by TARAZON.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 5 – MOTORCYCLE PARTS DISCLAIMER</h3>
        <p class="policy-text">
          Certain motorcycle parts sold by TARAZON may be intended for off-road, racing, testing, competition, or professional use only.
        </p>
        <p class="policy-text">
          Customers are solely responsible for ensuring that the purchase, installation, and use of such products comply with all applicable laws, regulations, and vehicle requirements in their country or region.
        </p>
        <p class="policy-text">
          TARAZON shall not be liable for any damages, injuries, penalties, or losses arising from improper installation, misuse, modification, or unlawful use of its products.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 6 – BILLING AND ACCOUNT INFORMATION</h3>
        <p class="policy-text">
          You agree to provide current, complete, and accurate information for all purchases made through this website.
        </p>
        <p class="policy-text">
          We reserve the right to refuse or cancel any order at our sole discretion.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 7 – THIRD-PARTY LINKS</h3>
        <p class="policy-text">
          This website may contain links to third-party websites. TARAZON is not responsible for the content, policies, or practices of such third-party websites.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 8 – PERSONAL INFORMATION</h3>
        <p class="policy-text">
          Your submission of personal information through this website is governed by our Privacy Policy.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 9 – PROHIBITED USES</h3>
        <p class="policy-text">
          You may not use this website for any unlawful purpose, to infringe intellectual property rights, distribute malicious software, transmit false information, or interfere with website security.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 10 – DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h3>
        <p class="policy-text">
          All products and services are provided on an "as is" and "as available" basis.
        </p>
        <p class="policy-text">
          To the maximum extent permitted by law, TARAZON shall not be liable for any indirect, incidental, consequential, or special damages arising from the use of this website or its products
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 11 – GOVERNING LAW</h3>
        <p class="policy-text">
          These Terms of Service shall be governed by and construed in accordance with the laws of the People's Republic of China.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 12 – CHANGES TO TERMS</h3>
        <p class="policy-text">
          TARAZON reserves the right to update, modify, or replace any part of these Terms of Service at any time by posting changes on this website
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">SECTION 13 – CONTACT INFORMATION</h3>
        <p class="policy-text">Questions regarding these Terms of Service may be directed to:</p>
        <p class="policy-text">
          Email:
          <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trsShopBreadcrumb from '@/components/layout/shopping/breadcrumb.vue';

export default {
  name: 'trsTermsService',
  mixins: [Mixin],
  components: {
    trsShopBreadcrumb
  },
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
          path: '/index'
        },
        {
          name: 'TERMS OF SERVICE',
          path: '/trsTermsService'
        }
      ]
    };
  },
};
</script>

<style scoped lang="less">
.policy-page {
  width: 1200px;
  margin: 0 auto;
}

.policy-page__breadcrumb {
  margin: 0 auto;
  width: 1200px;
}

.policy-content {
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: 32px 40px 40px;
  color: #333;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
  line-height: 1.8;
}

.policy-section {
  margin-bottom: 0;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-section__heading {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  line-height: 1.5;
}

.policy-text {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-divider {
  margin: 24px 0;
  border: 0;
  border-top: 1px solid #e8e8e8;
}

.policy-link {
  color: #333;
  text-decoration: none;

  &:hover {
    color: #89b92a;
    text-decoration: underline;
  }
}
</style>
